import { WESTEROS_MICROSERVICES_ENUM, westerosQuery } from '@/helpers/westeros';
import { getStudentCourseModuleStudyPlan } from '@/store/queries/westerosKingslandingQueries';
import { StudyPlanTemplateModel } from '@/models/kingslanding/studyPlanTemplateModel';

export interface GetStudentStudyPlanParams {
  courseId: number;
  moduleId: number;
  disciplineIds: number[];
}

export class Kingslanding {
  static async getStudentCourseModuleStudyPlan(
    args: GetStudentStudyPlanParams,
  ): Promise<StudyPlanTemplateModel> {
    const studentStudyPlanResponse = await westerosQuery(
      WESTEROS_MICROSERVICES_ENUM.KINGSLANDING,
      getStudentCourseModuleStudyPlan,
      {
        ...args,
      },
    );

    const {
      data: { getStudentStudyPlanTemplate },
    } = studentStudyPlanResponse;

    return getStudentStudyPlanTemplate as StudyPlanTemplateModel;
  }
}
